module.exports = __webpack_public_path__ + "img/03.0e3ce4c8.jpg";